// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../common/Components/Loader.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let MyBroadcastMessagesWidgetList = require("./MyBroadcastMessagesWidgetList.bs.js");

function MyBroadcastMessagesWidgetRelay(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("h2", {
          children: "My Broadcast Messages",
          className: "text-gray-700 text-2xl font-medium"
        }),
        className: "flex gap-4 items-center flex-row mb-4"
      }),
      JsxRuntime.jsx(React.Suspense, {
        children: JsxRuntime.jsx(MyBroadcastMessagesWidgetList.make, {
          query: props.query,
          viewMoreMode: props.viewMoreMode
        }),
        fallback: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loader.make, {
            loadingText: "Loading messages..."
          }),
          className: "h-[340px] flex items-center justify-center"
        })
      })
    ],
    className: "bg-white p-5 rounded shadow-sm"
  });
}

let make = MyBroadcastMessagesWidgetRelay;

exports.make = make;
/* react Not a pure module */
